import { clearVerifiedSession } from './verified-session';
import { boundedFetch } from './bounded-fetch';
import { setQueueScope } from './offline-queue';
import { apiUrl } from './api-config';

/**
 * Wrapper around fetch that automatically resolves API URLs for native vs web.
 * Drop-in replacement: apiFetch('/api/windrows', { ... })
 * Intercepts 401 responses to clear stale tokens and redirect to login.
 */
export async function apiFetch(path: string, init?: RequestInit): Promise<Response> {
  const res = await boundedFetch(apiUrl(path), init);
  const authorization = new Headers(init?.headers).get('Authorization');
  const currentToken = localStorage.getItem('compostdeveloper_token');
  if (res.status === 401 && currentToken && authorization === `Bearer ${currentToken}`) {
    // Token expired or invalid — clear and redirect
    setQueueScope(null);
    clearVerifiedSession();
    localStorage.removeItem("compostdeveloper_token");
    if (window.location.pathname.startsWith("/app")) {
      window.location.href = "/login?expired=true";
    }
  }
  return res;
}
